﻿<template>
    <tr>
        <td>{{get_Passenger()}}</td>
        <td class="bd-num">{{get_Price(trip_passenger?.commission ?? 0)}}</td>
        <td class="bd-num">{{get_Price(trip_passenger?.price ?? 0)}}</td>
        <td class="bd-center"><input type="checkbox" :checked="Cancel_Line()" @click="Toggle_Cancellation()" :aria-label="'Cancel ' + get_Passenger()" class="focus:ring-action h-4 w-4 text-action border-grey-light rounded"></td>
    </tr>
</template>

<script lang="ts" src="./booking_line_passenger.ts"></script>